import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ZavicService } from 'src/app/services/zavic.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-zavic-factor',
  templateUrl: './create-zavic-factor.component.html',
  styleUrls: []
})
export class CreateZavicFactorComponent implements OnInit {

  public zavicFactorForm = this.fb.group({
    lowDesc: ['', Validators.required],
    midDesc: ['', Validators.required],
    highDesc: ['', Validators.required],
    name: [''],
  });

  constructor(private fb: FormBuilder, private zavicservice: ZavicService) { }

  ngOnInit(): void {
  }

  register(){
    console.log(this.zavicFactorForm.value);
    this.zavicservice.createFactor(this.zavicFactorForm.value).subscribe(

      resp=>{
        this.zavicFactorForm.reset();
        let timerInterval
        Swal.fire({
          title: 'Pregunta creada',
          html: '',
          timer: 1000,
          timerProgressBar: true,
          willOpen: () => {
            Swal.showLoading()
          },
          onClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            
          }
        })
      },
      err=>{

      }

    )
  }

}
